import { getTempInfoCountryConfig } from '../constants/countries';
import { LDFlags } from '../constants/flags';
import { Maybe, TemporaryData } from '../gql/generated/graphql';
import useFlag from './useFlag';

const useIsSellingAvailable = (data?: Maybe<Pick<TemporaryData, 'country'>>) =>
  useFlag(LDFlags.KEEP_MY_CAR_SELECTOR) && !!data && getTempInfoCountryConfig(data).marketplaceFlow;

export default useIsSellingAvailable;
